import React from 'react'
import {Dialog, Transition} from '@headlessui/react'
import Card from 'features/common/components/Card'
import cross from 'assets/cross.svg'

const EmployeeModal = ({
    isOpen,
    onClose,
    children,
}: {
    isOpen: boolean
    onClose: () => void
    children: React.ReactNode
}) => {
    return (
        <Transition show={true}>
            <Transition.Child
                as={React.Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className="fixed top-0 left-0 z-10 h-screen w-screen cursor-pointer bg-grey-20 opacity-70" />
            </Transition.Child>
            <Dialog open={isOpen} onClose={onClose}>
                <Dialog.Panel>
                    <Card className="absolute top-1/2 left-1/2 z-10 flex -translate-y-1/2 -translate-x-1/2 flex-col items-stretch justify-between gap-10 p-12 text-center shadow-x">
                        <div className="flex justify-end">
                            <img
                                src={cross}
                                onClick={onClose}
                                className="h-6 w-6 cursor-pointer"
                                alt="exit"
                            />
                        </div>
                        {children}
                    </Card>
                </Dialog.Panel>
            </Dialog>
        </Transition>
    )
}

export default EmployeeModal
